import { formatDate } from "@utils/date.util";

const tableTitle = "Banner List";
const keyColumn = "id";
const menuUrl = "design/banners";

const tableColumn = [
    {
        id: "image",
        numeric: false,
        disablePadding: false,
        label: "Banner Image",
        type: "FILE_UPLOAD",
        formatData: (data) => {
          return (
            <img
              src={data}
              alt=" Image"
              style={{ width: "100px", height: "50px" }}
            />
          );
        },
      },
      {
    id: "name",
    numeric: false,
    disablePadding: false,
    label: "Banner Name",
    },
    
  {
    id: "sort_order",
    numeric: false,
    disablePadding: false,
    label: "Sort Order",
  },
  {
    id: "url",
    numeric: false,
    disablePadding: false,
    label: "Link",
  },
   {
    id: "created_at",
    numeric: false,
    disablePadding: false,
    label: "Created At",
    formatData: formatDate,
    sort: true,
},
  {
    id: "status",
    numeric: false,
    disablePadding: false,
    label: "Status",
    isBadge: true,
    primaryKey: keyColumn,
    badgeText: {
      1: "Enable",
      2: "Disable",
    },
    badgeColor: {
      1: "success",
      2: "danger",
    },

  },
];

const breadCrumbs = [
  { name: "Banners", menu_url: "/design/banners" },
];

const filters = () => [
  {
    name: "banner_name",
    id: "banner_name",
    label: "Banner Name",
    value: "",
    type: "TEXT",
    validations: [],
    isVertical: true,
    groupClass: "col-md-3",
  },
  
];

export {
  tableTitle,
  keyColumn,
  tableColumn,
  breadCrumbs,
  menuUrl,
  filters,
};
